import React from 'react';
import { authProtectedRoutes } from 'helpers/customNavigationRules';

import { SiteConfigManager } from '@atlas/core';

import { PLATFORM_TYPES } from 'common/constants';

import SimpleMenuItem from './SimpleMenuItem';

const { MOBILE, MULTIPLATFORM } = PLATFORM_TYPES;

const SimpleMenu = () => {
  const topNavigation = React.useMemo(() => SiteConfigManager.getConfig('navigation.top'), []);

  if (Array.isArray(topNavigation) && topNavigation.length > 0) {
    const content = topNavigation
      .filter(({ platform_type }) => platform_type === MULTIPLATFORM || platform_type === MOBILE)
      .sort((a, b) => a.order_index - b.order_index)
      .map(({ location, name }) => (
        <SimpleMenuItem
          authRequired={authProtectedRoutes.includes(location)}
          key={name}
          label={name}
          link={location}
        />
      ));

    return <menu className="simple-menu">{content}</menu>;
  }

  return null;
};

export default SimpleMenu;
